(function() {
    const VERSION_INIT_ATTRIBUTE = "data-version-init";
    const ACTIVE_CLASS = "is-active";
    const VERSION_CONTAINER_ATTRIBUTE = "data-version-container";
    const loadedImages = {};

    const initializeVersions = () => {
        document.querySelectorAll("[data-versions]").forEach(initializeProductVersions);
    };

    function initializeProductVersions(productElement) {
        const versionButtons = productElement.querySelectorAll(`[${VERSION_INIT_ATTRIBUTE}]`);
        
        versionButtons.forEach((button) => {
            initializeVersionButton(button, versionButtons, productElement);
        });

        preloadProductImages(productElement);
    }

    function initializeVersionButton(button, allButtons, productElement) {
        button.addEventListener("click", function() {
            allButtons.forEach((btn) => btn.classList.remove(ACTIVE_CLASS));
            button.classList.add(ACTIVE_CLASS);

            const versionContainers = productElement.querySelectorAll(`[${VERSION_CONTAINER_ATTRIBUTE}]`);
            const selectedVersion = button.getAttribute("data-version-button");

            versionContainers.forEach((container) => {
                container.classList.toggle("d-none", container.getAttribute(VERSION_CONTAINER_ATTRIBUTE) !== selectedVersion);
            });
        });

        button.removeAttribute(VERSION_INIT_ATTRIBUTE);
    }

    function preloadProductImages(productElement) {
        productElement.querySelectorAll(`[${VERSION_CONTAINER_ATTRIBUTE}] img`).forEach((img) => {
            const src = img.getAttribute("src") || "";
            const srcset = img.getAttribute("srcset") || "";
            const imageKey = `${src}##${srcset}`;

            if (loadedImages[imageKey]) return;

            const preloadImage = new Image();
            preloadImage.width = 450;
            preloadImage.height = 618;
            preloadImage.src = src;
            preloadImage.srcset = srcset;
            loadedImages[imageKey] = true;
        });
    }

    document.addEventListener("ajaxinate", initializeVersions);
    document.addEventListener("DOMContentLoaded", initializeVersions);
    document.addEventListener("filtered", initializeVersions);
    document.addEventListener("wishlist-loaded", initializeVersions);

    window.initializeProductVersions = initializeProductVersions;
})();